export default "__VITE_ASSET__d7eb137b__"